import { render, staticRenderFns } from "./BaseBulkUpdate.vue?vue&type=template&id=41751bfc&scoped=true"
import script from "./BaseBulkUpdate.vue?vue&type=script&lang=js"
export * from "./BaseBulkUpdate.vue?vue&type=script&lang=js"
import style0 from "./BaseBulkUpdate.vue?vue&type=style&index=0&id=41751bfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41751bfc",
  null
  
)

export default component.exports